import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class SpinnerService {
  public enableSpinner: ReplaySubject<boolean> = new ReplaySubject(0);
  constructor() {}
}
